import { render, staticRenderFns } from "./postcode-check.vue?vue&type=template&id=42fec933&scoped=true"
import script from "./postcode-check.vue?vue&type=script&lang=js"
export * from "./postcode-check.vue?vue&type=script&lang=js"
import style0 from "./postcode-check.vue?vue&type=style&index=0&id=42fec933&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fec933",
  null
  
)

export default component.exports